import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export type EntityType = 'client' | 'customer' | 'location' | 'device' | 'user' | 'brand';

@Injectable({
  providedIn: 'root'
})
export class S3UrlService {

  /**
   * Gets the S3 bucket URL for a specific entity type
   */
  getS3BucketUrl(entityType: EntityType): string {
    let url = environment.s3BucketUrl.replace('{module}', entityType);

    if (environment.accountId) {
      url = url.replace('{accountId}', environment.accountId);
    } else {
      url = url.replace('{accountId}', '');
    }

    return url;
  }

  /**
   * Gets the full S3 URL for a logo image
   */
  getLogoUrl(entityType: EntityType, logoFileName: string): string {
    if (!logoFileName) {
      return '';
    }
    return `${this.getS3BucketUrl(entityType)}/logo/${logoFileName}`;
  }

  getFavUrl(entityType: EntityType, favFileName: string): string {
    if (!favFileName) {
      return '';
    }
    return `${this.getS3BucketUrl(entityType)}/fav/${favFileName}`;
  }

  /**
   * Gets the full S3 URL for any file type
   */
  getS3Url(entityType: EntityType, folder: string, fileName: string): string {
    if (!fileName) {
      return '';
    }
    return `${this.getS3BucketUrl(entityType)}/${folder}/${fileName}`;
  }
}